import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {DigitalizedSignatureValues} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormFramework from './InnerFormDocsSign';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';

DocsInfoForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    sign: PropTypes.any,
    signed: PropTypes.bool.isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof DocsInfoForm.propTypes>,
    DigitalizedSignatureValues
>({
    mapPropsToErrors: () => {
        return {
            signature: '',
            informationCheck: '',
            signed: ''
        };
    },
    mapPropsToValues: (props) => {
        return {
            signed: props.signed,
            signature: props.sign || '',
            informationCheck: props.sign ? true : false,
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: DigitalizedSignatureValues, props) => {
        const errors: FormikErrors<DigitalizedSignatureValues> = {};
        formValidator(props.fields, errors, values);
        if (!values.signature) {
            errors.signature = Messages.SIGNATURE_NOT_CAPTURED;
        }
        if(!values.informationCheck){
            errors.informationCheck = Messages.ACCEPT_THE_TERMS;
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormFramework);

function DocsInfoForm(props: InferPropTypes<typeof DocsInfoForm.propTypes>) {
    const {submitHandler, fields, sign, signed} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl fields={fields} submitHandler={submitHandler} sign={sign} signed={signed} />
    );
}

export default DocsInfoForm;
